// @flow

export function currencyString(value: number) {
  if (typeof value === 'number') {
    const number = String(value).split('.');
    return `kr. ${number[0]
      .substr(0, 6)
      .replace(/^([0-9]{1,3})([0-9]{3})+$/, (m, p1, p2) => `${p1}.${p2}`)}${
      number.length === 2 ? `,${number[1]}` : ''
    }`;
  }
  return value;
}
